import { useMutation } from "react-query";
import { getLEForDownload } from "../../../../actions/CarrierAgreementMgmt/LeasedEquipment";
const useGetLeasedEquipmentForDownload = () => {
  return useMutation(getLEForDownload);
};
export default useGetLeasedEquipmentForDownload;
